import { Enum } from 'enumify';

export default class RequestType extends Enum {}

RequestType.initEnum(['PUT', 'POST', 'GET', 'DELETE', 'PATCH']);